(function(){
  var COLORS  = ['K','J','I','H','G','F','E','D'];
  var CLARITY = ['SI2','SI1','VS2','VS1','VVS2','VVS1','IF','FL'];
  var CUT     = ['Good','Very Good','Excellent','Ideal'];

  var DEFAULTS = {
    price:   { min: 100,  max: 17000 },
    carat:   { min: 0.30, max: 15.00 },
    cut:     { min: 0, max: CUT.length - 1,     values: CUT },
    color:   { min: 0, max: COLORS.length - 1,  values: COLORS },
    clarity: { min: 0, max: CLARITY.length - 1, values: CLARITY }
  };

  var SLIDER_ID = {
    price: 'filter__price',
    carat: 'filter__carat',
    cut: 'filter__cut',
    color: 'filter__color',
    clarity: 'filter__clarity'
  };

  var touched = { price: false, carat: false, cut: false, color: false, clarity: false };
  var wired   = { price: false, carat: false, cut: false, color: false, clarity: false };

  function fmtMoney(n) {
    if (n >= 1000) {
      var k = n / 1000;
      return '$' + (k % 1 === 0 ? k : k.toFixed(1)) + 'k';
    }
    return '$' + Math.round(n);
  }

  function getSliderRange(key) {
    var container = document.getElementById(SLIDER_ID[key]);
    if (!container) return null;
    var slider = container.querySelector('.range-slider');
    if (!slider || !slider.noUiSlider) return null;
    var v = slider.noUiSlider.get();
    if (!Array.isArray(v)) return null;
    return [parseFloat(v[0]), parseFloat(v[1])];
  }

  function sliderChipValue(key, range) {
    var d = DEFAULTS[key];
    if (key === 'price') {
      return fmtMoney(range[0]) + ' – ' + fmtMoney(range[1]) + (range[1] >= d.max ? '+' : '');
    }
    if (key === 'carat') {
      return range[0].toFixed(2) + ' – ' + range[1].toFixed(2) + (range[1] >= d.max ? '+ ct' : ' ct');
    }
    var lo = d.values[Math.round(range[0])];
    var hi = d.values[Math.round(range[1])];
    return lo === hi ? lo : (lo + ' – ' + hi);
  }

  function resetSlider(key) {
    var container = document.getElementById(SLIDER_ID[key]);
    var slider = container && container.querySelector('.range-slider');
    var d = DEFAULTS[key];

    // Reset native slider + its inputs
    if (slider && slider.noUiSlider) {
      try { slider.noUiSlider.set([d.min, d.max], true, true); } catch(e){}
      var startInp = container.querySelector('.slider-start-value');
      var endInp = container.querySelector('.slider-end-value');
      if (startInp) { startInp.value = d.min; ['input','change','keyup','blur'].forEach(function(n){ startInp.dispatchEvent(new Event(n,{bubbles:true})); }); }
      if (endInp)   { endInp.value   = d.max; ['input','change','keyup','blur'].forEach(function(n){ endInp.dispatchEvent(new Event(n,{bubbles:true})); }); }
      try { slider.dispatchEvent(new Event('change',{bubbles:true})); } catch(e){}
      if (window.jQuery) { try { window.jQuery(slider).trigger('change'); } catch(e){} }
    }

    // Also reset the polish bar UI (sp-bn__col custom range inputs)
    var polishCol = document.querySelector('.sp-bn__col[data-key="'+key+'"]');
    if (polishCol) {
      var minH = polishCol.querySelector('.sp-rng__handle--min');
      var maxH = polishCol.querySelector('.sp-rng__handle--max');
      if (minH && maxH) {
        minH.value = d.min;
        maxH.value = d.max;
        // Fire input events so the polish bar updates its own fill/value display
        minH.dispatchEvent(new Event('input', { bubbles: true }));
        maxH.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }

    touched[key] = false;
  }

  function wireSliderTouched(key) {
    if (wired[key]) return;

    // Primary: polish bar custom range inputs — where users actually drag
    var polishCol = document.querySelector('.sp-bn__col[data-key="'+key+'"]');
    if (polishCol) {
      polishCol.querySelectorAll('input[type="range"]').forEach(function(inp){
        inp.addEventListener('input', function(e){
          if (!e.isTrusted) return;       // ignore programmatic
          touched[key] = true;
          render();
        });
      });
      wired[key] = true;
      return;
    }

    // Fallback: native noUiSlider if polish bar isn't rendered yet
    var container = document.getElementById(SLIDER_ID[key]);
    if (!container) return;
    var slider = container.querySelector('.range-slider');
    if (!slider || !slider.noUiSlider) return;
    try {
      slider.noUiSlider.on('start', function(){ touched[key] = true; render(); });
    } catch(e){}
    ['.slider-start-value','.slider-end-value'].forEach(function(sel){
      var inp = container.querySelector(sel);
      if (!inp) return;
      inp.addEventListener('change', function(e){
        if (!e.isTrusted) return;
        touched[key] = true;
        render();
      });
    });
    wired[key] = true;
  }

  function wireAllSliders() {
    ['price','carat','cut','color','clarity'].forEach(wireSliderTouched);
  }

  function getActiveShapes() {
    return Array.from(document.querySelectorAll('#filter__shape .shape.filter__item.slide-active')).map(function(el){
      return { el: el, label: (el.getAttribute('data-value') || el.textContent || '').trim() };
    });
  }
  function getActiveReports() {
    return Array.from(document.querySelectorAll('#filter__report .text-box.filter__item.slide-active, .filter__report .text-box.filter__item.slide-active, [id*="filter__report"] .filter__item.slide-active')).map(function(el){
      return { el: el, label: (el.getAttribute('data-value') || el.textContent || '').trim() };
    });
  }

  function getFeaturedDealCheckbox() {
    return document.querySelector('input[type="checkbox"][name*="featured" i], input[type="checkbox"][id*="featured" i], input[type="checkbox"][class*="featured" i]');
  }
  function getQuickShipCheckbox() {
    return document.querySelector('input[type="checkbox"][name*="quick" i], input[type="checkbox"][id*="quick" i], input[type="checkbox"][class*="quick" i]');
  }

  function capitalize(s) { return s ? s.charAt(0).toUpperCase() + s.slice(1).toLowerCase() : ''; }

  function ensureChipsContainer() {
    var c = document.getElementById('sp-chips');
    if (c) return c;
    c = document.createElement('div');
    c.id = 'sp-chips';
    c.className = 'sp-chips';
    var anchor = document.querySelector('.diamond-filter__wrapper');
    if (anchor && anchor.parentNode) {
      if (anchor.nextSibling) anchor.parentNode.insertBefore(c, anchor.nextSibling);
      else anchor.parentNode.appendChild(c);
    } else {
      (document.querySelector('.diamonds-list-container') || document.body).prepend(c);
    }
    return c;
  }

  function buildChip(labelText, valueText, onRemove) {
    var chip = document.createElement('span');
    chip.className = 'sp-chip';
    var lbl = document.createElement('span');
    lbl.className = 'sp-chip__label';
    lbl.textContent = labelText;
    var val = document.createElement('span');
    val.className = 'sp-chip__value';
    val.textContent = valueText;
    var x = document.createElement('button');
    x.type = 'button';
    x.className = 'sp-chip__x';
    x.setAttribute('aria-label', 'Remove ' + labelText + ' filter');
    x.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); onRemove(); setTimeout(render, 60); });
    chip.appendChild(lbl);
    chip.appendChild(val);
    chip.appendChild(x);
    return chip;
  }

  function render() {
    wireAllSliders();
    var container = ensureChipsContainer();
    container.innerHTML = '';
    var chipsAdded = 0;

    getActiveShapes().forEach(function(sh){
      var chip = buildChip('Shape', capitalize(sh.label), function(){ sh.el.click(); });
      container.appendChild(chip);
      chipsAdded++;
    });

    ['price','carat','cut','color','clarity'].forEach(function(key){
      if (!touched[key]) return;
      var r = getSliderRange(key);
      if (!r) return;
      var chip = buildChip(key.toUpperCase(), sliderChipValue(key, r), function(){ resetSlider(key); });
      container.appendChild(chip);
      chipsAdded++;
    });

    getActiveReports().forEach(function(rep){
      var chip = buildChip('Cert', rep.label.toUpperCase(), function(){ rep.el.click(); });
      container.appendChild(chip);
      chipsAdded++;
    });

    var fd = getFeaturedDealCheckbox();
    if (fd && fd.checked) {
      container.appendChild(buildChip('Deal', 'Featured', function(){ fd.click(); }));
      chipsAdded++;
    }
    var qs = getQuickShipCheckbox();
    if (qs && qs.checked) {
      container.appendChild(buildChip('Ship', 'Quick', function(){ qs.click(); }));
      chipsAdded++;
    }

    if (chipsAdded > 0) {
      var clear = document.createElement('button');
      clear.type = 'button';
      clear.className = 'sp-chips__clear';
      clear.textContent = 'Clear all';
      clear.addEventListener('click', function(){
        getActiveShapes().forEach(function(s){ s.el.click(); });
        ['price','carat','cut','color','clarity'].forEach(resetSlider);
        getActiveReports().forEach(function(r){ r.el.click(); });
        if (fd && fd.checked) fd.click();
        if (qs && qs.checked) qs.click();
        setTimeout(render, 80);
      });
      container.appendChild(clear);
    }
  }

  function start() {
    render();
    var root = document.querySelector('.diamond-filter__wrapper') || document.body;
    if (root && window.MutationObserver) {
      var mo = new MutationObserver(function(){
        clearTimeout(window.__spChipsT);
        window.__spChipsT = setTimeout(render, 120);
      });
      mo.observe(root, { attributes: true, attributeFilter: ['class','value'], subtree: true, childList: true });
    }
    document.addEventListener('change', function(e){
      var t = e.target;
      if (t && t.closest && t.closest('.diamond-filter__wrapper, #filter__shape, [id*="filter__"]')) {
        clearTimeout(window.__spChipsT);
        window.__spChipsT = setTimeout(render, 120);
      }
    }, true);

    setTimeout(wireAllSliders, 400);
    setTimeout(wireAllSliders, 1200);
    setTimeout(wireAllSliders, 3000);
    setTimeout(render, 500);
    setTimeout(render, 1500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
